import { apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  fieldAudit: null,
  currentFieldAudit: {},
  fieldAuditUnits: {},
  auditUnit: null,
}

const createFieldAuditsSlice = (set, get) => ({
  ...initialState,
  fetchFieldAudit: async (id, onSuccess = null) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/field_audits/${id}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ fieldAudit: data.data }))
      if (onSuccess) { onSuccess() }
    } catch (err) {
      get().logError('Unable to retrieve field audit at this time.', err)
    }
  },
  createFieldAudit: async (dealerId, onSuccess = null) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/field_audits`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify({ dealer_id: dealerId })
        }
      )
      const data = await response.json()

      if (response.status === 200) {
        set((state) => ({ fieldAudit: data.data }))
        if (onSuccess) { onSuccess(data.data) }
      } else {
        get().setErrMessage(data.errors[0])
      }
    } catch (err) {
      get().setErrMessage('There was an error creating this field audit.')
      get().logError('There was an error creating this field audit.', err)
    }
  },
  updateFieldAudit: async (id, body, onSuccess = null) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/field_audits/${id}`,
        {
          headers: get().requestHeaders,
          method: 'PUT',
          body: JSON.stringify({ eaudit: body })
        }
      )
      const data = await response.json()
      set(() => ({ fieldAudit: data.data }))
      if (onSuccess) { onSuccess() }
    } catch (err) {
      get().logError('Unable to update field audit at this time.', err)
    }
  },
  fetchFieldAuditUnits: async (id, onSuccess = null) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/field_audits/${id}/units?per_page=300`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ fieldAuditUnits: data }))
      if (onSuccess) { onSuccess() }
    } catch (err) {
      get().logError('Unable to retrieve field audit units at this time.', err)
    }
  },
  fetchAuditUnit: async (fieldAuditId, auditUnitId, onSuccess = null) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/field_audits/${fieldAuditId}/units/${auditUnitId}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ auditUnit: data.data }))
      if (onSuccess) { onSuccess() }
    } catch (err) {
      get().logError('Unable to retrieve audit unit at this time.', err)
    }
  },
  updateAuditUnit: async (fieldAuditId, auditUnitId, body, onSuccess = null) => {
    try {
      const headers = {...get().requestHeaders}

      if (body instanceof FormData) {
        delete headers['Content-Type']
      }

      const response = await fetch(
        `${apiUrlV2}/field_audits/${fieldAuditId}/units/${auditUnitId}`,
        {
          headers: headers,
          method: 'PUT',
          body: body
        }
      )
      const responseData = await response.json()

      if (response.status === 200) {
        set((state) => ({
          auditUnit: responseData.data,
          fieldAuditUnits: {
            ...state.fieldAuditUnits,
            data: state.fieldAuditUnits.data?.map(unit =>
              unit.id === auditUnitId ? responseData.data : unit
            )
          }
        }))
        if (onSuccess) { onSuccess() }
      } else {
        get().setErrMessage('Unable to update audit unit at this time.')
      }
    } catch (err) {
      get().logError('Unable to update audit unit at this time.', err)
    }
  },
  setAuditUnit: (auditUnit) => set({ auditUnit }),
  setCurrentFieldAudit: (fieldAudit) => set({ currentFieldAudit: fieldAudit }),
  resetFieldAuditsSlice: () => set(initialState)
})

export default createFieldAuditsSlice